let AppSettings = {...JSON.parse(sessionStorage.getItem('webConfig'))};

export default AppSettings;